import { analyticsNumberFormatter } from '../utils/parser.js'

export const PieChartLabel = ({ viewBox, value }) => {
  const fontSize = Math.min(viewBox.innerRadius / 2.5, 15)

  return (
    <g>
      <text
        x={viewBox.cx}
        y={viewBox.cy + Math.floor(fontSize / 2)}
        fontSize={fontSize}
        textAnchor="middle"
        className="fill-content"
      >
        {analyticsNumberFormatter(value)}
      </text>
    </g>
  )
}
